var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00f9bb;}.cls-2{fill:#ef84f5;}.cls-3{fill:#6067f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1849.33,575.59l-109.78-41.45-609.27,230.04c-94.22,35.58-246.98,35.58-341.21,0L180.12,534.26l-109.46,41.33c-94.22,35.58-94.22,93.25,0,128.83l718.73,271.37c94.22,35.58,246.98,35.58,341.21,0l718.73-271.37c94.22-35.58,94.22-93.25,0-128.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1849.33,298.05L1130.6,26.68c-94.22-35.58-246.98-35.58-341.21,0L70.67,298.05c-94.22,35.58-94.22,93.25,0,128.83l718.73,271.37c94.22,35.58,246.98,35.58,341.21,0l718.73-271.37c94.22-35.58,94.22-93.25,0-128.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1849.33,853.12l-109.78-41.45-609.27,230.04c-94.22,35.58-246.98,35.58-341.21,0L180.12,811.79l-109.46,41.33c-94.22,35.58-94.22,93.25,0,128.83l718.73,271.37c94.22,35.58,246.98,35.58,341.21,0l718.73-271.37c94.22-35.58,94.22-93.25,0-128.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.58b17ff46b20e154629a7c19dd87dafd.svg";
export { ForwardRef as ReactComponent };